//Node Modules
import axios from 'axios'

export function downloadSecureKey( cdcId: string, cdcVersion: string, accessKey: string): Promise<void> {
  return axios.post(`/collections/${cdcId}/${cdcVersion}/download/secure`, accessKey,  {headers: {"Content-Type": "text/plain"}})
}

export function cdcSecureKey( cdcId: string, cdcVersion: string, accessKey: string, inapp?: boolean): Promise<void> {
  return axios.post(`/collections/${cdcId}/${cdcVersion}/secure${inapp ? '?requestor=inapp' : ''}`, accessKey,  {headers: {"Content-Type": "text/plain"}})
}

export function docsetSecureKey( docsetId: string, docsetVersion: string, accessKey: string): Promise<void> {
  return axios.post(`/docsets/${docsetId}/${docsetVersion}/secure`, accessKey,  {headers: {"Content-Type": "text/plain"}})
}